// A programme session you write yourself (#173): typed the way Free
// training's checklist is ("bench 3x8 80", "pull-ups", "row 2k"), then saved
// to the slot and run in the Coach like a built session.
//
// The checklist's steps carry no rests (you tick them off in any order), so
// each block of sets gets one here, for the Coach to time between sets.
//
// Pure and React-free, so it can be unit-tested.

import { genStableId } from "./planEditing";
import { isRecoveryType } from "./planNodeUtils";

/** Rest between sets, in seconds, when you didn't set one. */
export const WRITTEN_SET_REST_S = 90;

const withSetRest = (node) => {
  if (!node || !Array.isArray(node.children)) return node;
  const children = node.children.map(withSetRest);
  const isSets =
    String(node.unit || "").toLowerCase() === "sets" && Number(node.value) > 1;
  if (!isSets || children.some((c) => isRecoveryType(c.type))) {
    return { ...node, children };
  }
  return {
    ...node,
    children: [
      ...children,
      { id: genStableId(), type: "Rest", label: "Rest", unit: "s", value: WRITTEN_SET_REST_S },
    ],
  };
};

// What each programme day kind (config/periodisation.js DAY_KINDS) counts
// toward in the weekly targets.
const DAY_KIND_COUNTS_AS = {
  resistance: ["resistance"],
  resistance_intervals: ["resistance", "anaerobic"],
  intervals: ["anaerobic"],
  zone2: ["aerobic"],
  zone2_sprints: ["anaerobic", "aerobic"],
  vo2max: ["aerobic"],
};

/** What a session written for a slot of this day kind counts as, by default. */
export const countsAsForDayKind = (kind) => DAY_KIND_COUNTS_AS[kind] || ["resistance"];

/**
 * The written plan as the slot's session: named for the slot, with a rest
 * after each set, and what it counts toward (#173): a slot's name, like
 * "Lower Body", says nothing the weekly targets can read. Null when nothing
 * has been written.
 */
export const writtenSessionPlan = (plan, label = "Session", countsAs) => {
  if (!plan || !Array.isArray(plan.children) || plan.children.length === 0) {
    return null;
  }
  const written = { ...withSetRest(plan), label };
  return Array.isArray(countsAs) ? { ...written, countsAs } : written;
};
